export default __webpack_public_path__ + "static/media/A.17652ee2.svg";